/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Grid, Switch, Typography } from "@mui/material";
import DatePicker from "react-flatpickr";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import SoftTypography from "components/SoftTypography";

const tableStyle = {
  borderCollapse: "collapse",

  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "wrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",

  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};
const dataTable = [
  {
    id: uuidV4(),
    stt: "1",
    asset:
      "Doanh thu hoạt động (1)=(1.1)+(1.2)+(1.3)+(1.4)+(1.5)+(1.6)+(1.7)+(1.8)+(1.9)+(1.10)+(1.11)",
    readOnly: true,
    value: {
      value3: { value: "", readOnly: false },
      value4: { value: "", readOnly: false },
      value5: { value: "", readOnly: false },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "1.1",
    asset:
      "Lãi từ các tài sản tài chính ghi nhận thông qua lãi/lỗ (FVTPL) (1.1)=(1.1.a)+(1.1.b)+(1.1.c)",
    readOnly: true,
    value: {
      value3: { value: "", readOnly: false },
      value4: { value: "", readOnly: false },
      value5: { value: "", readOnly: false },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "1.1.a",
    asset: "Lãi bán các tài sản tài chính FVTPL",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "1.1.b",
    asset: "Chênh lệch tăng về đánh giá lại các TSTC FVTPL",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "1.1.c",
    asset: "Cổ tức, tiền lãi phát sinh từ tài sản tài chính FVTPL",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "1.2",
    asset: "Lãi từ các khoản đầu tư nắm giữ đến ngày đáo hạn (HTM)",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "1.3",
    asset: "Lãi từ các khoản cho vay và và phải thu",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "1.4",
    asset: "Lãi từ tài sản tài chính sẵn sàng để bán (AFS)",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "1.5",
    asset: "Lãi từ các công cụ phái sinh phòng ngừa rủi ro",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "1.6",
    asset: "Doanh thu nghiệp vụ môi giới chứng khoán",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "1.7",
    asset: "Doanh thu nghiệp vụ bảo lãnh, đại lý phát hành chứng khoán",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "1.8",
    asset: "Doanh thu nghiệp vụ tư vấn đầu tư chứng khoán",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "1.9",
    asset: "Doanh thu nghiệp vụ lưu ký chứng khoán",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "1.10",
    asset: "Doanh thu hoạt động tư vấn tài chính",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "1.11",
    asset: "Thu nhập hoạt động khác",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "2",
    asset:
      "Chi phí hoạt động (2)=(2.1)+(2.2)+(2.3)+(2.4)+(2.5)+(2.6)+(2.7)+(2.8)+(2.9)+(2.10)+(2.11)+(2.12)",
    readOnly: true,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "2.1",
    asset:
      "Lỗ các tài sản tài chính ghi nhận thông qua lãi/lỗ (FVTPL) (2.1)=(2.1.a)+(2.1.b)+(2.1.c)",
    readOnly: true,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "2.1.a",
    asset: "Lỗ bán các tài sản tài chính FVTPL",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "2.1.b",
    asset: "Chênh lệch giảm đánh giá lại các TSTC FVTPL",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "2.1.c",
    asset: "Chi phí giao dịch mua các tài sản tài chính FVTPL",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "2.2",
    asset: "Lỗ các khoản đầu tư nắm giữ đến ngày đáo hạn (HTM)",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "2.3",
    asset:
      "Lỗ và ghi nhận chênh lệch đánh giá theo giá trị hợp lý tài sản tài chính sẵn sàng để bán (AFS) khi phân loại lại",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "2.4",
    asset:
      "Chi phí dự phòng tài sản tài chính, xử lý tổn thất các khoản phải thu khó đòi và lỗ suy giảm tài sản tài chính và chi phí đi vay của các khoản cho vay",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "2.5",
    asset: "Lỗ từ các tài sản tài chính phái sinh phòng ngừa rủi ro",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "2.6",
    asset: "Chi phí hoạt động tự doanh",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "2.7",
    asset: "Chi phí nghiệp vụ môi giới chứng khoán",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "2.8",
    asset: "Chi phí nghiệp vụ bảo lãnh, đại lý phát hành chứng khoán",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "2.9",
    asset: "Chi phí nghiệp vụ tư vấn đầu tư chứng khoán",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "2.10",
    asset: "Chi phí nghiệp vụ lưu ký chứng khoán",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "2.11",
    asset: "Chi phí hoạt động tư vấn tài chính",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "2.12",
    asset: "Chi phí các dịch vụ khác",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "3",
    asset: "Doanh thu hoạt động tài chính (3)=(3.1)+(3.2)+(3.3)+(3.4)",
    readOnly: true,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "3.1",
    asset: "Chênh lệch tỷ giá hối đoái đã và chưa thực hiện",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "3.2",
    asset: "Doanh thu, dự thu cổ tức, lãi tiền gửi ngân hàng không cố định",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "3.3",
    asset: "Lãi bán, thanh lý các khoản đầu tư vào công ty con, liên kết, liên doanh",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "3.4",
    asset: "Doanh thu khác về đầu tư",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "4",
    asset: "Chi phí tài chính (4)=(4.1)+(4.2)+(4.3)+(4.4)+(4.5)",
    readOnly: true,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "4.1",
    asset: "Chênh lệch tỷ giá hối đoái đã và chưa thực hiện",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "4.2",
    asset: "Chi phí lãi vay",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "4.3",
    asset: "Lỗi bán, thanh lý các khoản đầu tư vào công ty con, liên kết, liên doanh",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "4.4",
    asset: "Chi phí dự phòng suy giảm giá trị các khoản đầu tư tài chính dài hạn",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "4.5",
    asset: "Chi phí tài chính khác",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "5",
    asset: "Chi phí bán hàng ",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "6",
    asset: "Chi phí quản lý công ty chứng khoán",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "7",
    asset: "Kết quả hoạt động (7)=(1)-(2)+(3)-(4)-(5)-(6)",
    readOnly: true,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "8",
    asset: "Tổng lãi tiền gửi và lãi cho vay phát sinh trong kỳ",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "9",
    asset: "Tổng chi phí lãi vay phát sinh trong kỳ",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "9.1",
    asset: "Chi phí lãi vay được trừ trong kỳ",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "9.2",
    asset:
      "Phần chi phí lãi vay trong kỳ không được trừ chuyển sang kỳ sau theo quy định tại điểm b khoản 3 Điều 16",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "10",
    asset: "Chi phí khấu hao phát sinh trong kỳ",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "11",
    asset:
      "Tổng lợi nhuận thuần từ hoạt động kinh doanh trong kỳ cộng chi phí lãi vay sau khi trừ lãi tiền gửi và lãi cho vay phát sinh trong kỳ cộng chi phí khấu hao phát sinh trong kỳ (11)=(7)+(9)-(8)+(10)",
    readOnly: true,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "12",
    asset:
      "Tỷ lệ chi phí lãi vay sau khi trừ lãi tiền gửi và lãi cho vay phát sinh trong kỳ trên tổng lợi nhuận thuần từ hoạt động kịnh doanh cộng chi phí lãi vay sau khi trừ lãi tiền gửi và lãi cho vay trong kỳ cộng chi phí khấu hao phát sinh trong kỳ (12)=[(9)-(8)]/(11)",
    readOnly: true,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "13",
    asset:
      "Chi phí lãi vay của các kỳ trước chuyển sang (13)=(13.1)+(13.2)+(13.3)+(13.4)+(13.5) trong đó:",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "13.1",
    asset: "- Phần chi phí lãi vay không được trừ từ năm (n-1) chuyển sang kỳ tính thuế (n)",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "13.2",
    asset: "- Phần chi phí lãi vay không được trừ từ năm (n-2) chuyển sang kỳ tính thuế (n)",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "13.3",
    asset: "- Phần chi phí lãi vay không được trừ từ năm (n-3) chuyển sang kỳ tính thuế (n)",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "13.4",
    asset: "- Phần chi phí lãi vay không được trừ từ năm (n-4) chuyển sang kỳ tính thuế (n)",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "13.5",
    asset: "- Phần chi phí lãi vay không được trừ từ năm (n-5) chuyển sang kỳ tính thuế (n)",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "14",
    asset:
      "Tỷ lệ chi phí lãi vay sau khi trừ lãi tiền gửi và lãi cho vay phát sinh được trừ trong kỳ cộng chi phí lãi vay của các kỳ trước chuyển sang kỳ tính thuế (n) trên tổng lợi nhuận thuần từ hoạt động kinh doanh cộng chi phí lãi vay thuần phát sinh trong kỳ cộng chi phí khấu hao phát sinh trong kỳ của người nộp thuế (14)=[(9)-(8)+(13)]/(11)",
    readOnly: true,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "15",
    asset: "Tỷ suất lợi nhuận sử dụng xác định giá giao dịch liên kết",
    readOnly: true,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: "", readOnly: true },
    },
  },
];
const stt = [
  "a",
  "b",
  "c",
  "d",
  "đ",
  "e",
  "g",
  "h",
  "i",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "x",
  "y",
];
export default function TableGDLK01f({ formData, setFieldValue }) {
  const [data1, setData1] = useState(false);
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  useEffect(() => {
    console.log(data1);
  }, [data1]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  // 1.2.abc
  const [data2, setData2] = useState([
    {
      id: uuidV4(),
      content: "",
      value3: 0,
      value4: 0,
      value5: "",
      value6: "",
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable2", data2);
  }, [data2]);
  const handleChange2 = (values) => {
    const { id, name, value, type } = values;
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data2 });
  };
  const handleChangeDate2 = (date, id) => {
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect2 = (id, name, value) => {
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd2 = () => {
    setData2((prev) => [
      ...prev,
      {
        id: uuidV4(),
        content: "",
        value3: 0,
        value4: 0,
        value5: 0,
        value6: "",
        value7: 0,
        value8: 0,
        value9: 0,
        value10: "",
        value11: 0,
        value12a: 0,
        value12b: 0,
        value12c: 0,
        value12d: 0,
        value13: false,
      },
    ]);
  };
  const handleDelete2 = (id) => {
    setData2((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-start">
        <Typography variant="h6">3. Dành cho người nộp thuế là các công ty chứng khoán</Typography>
      </Box>
      <Box>
        <table style={{ ...tableStyle, marginBottom: 50, marginTop: 50 }}>
          <tbody>
            <tr>
              <Td
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                }}
              >
                Người nộp thuế đã ký thỏa thuận trước về phương pháp xác định giá thuế (APA)
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  maxWidth: 100,
                }}
              >
                <Switch checked={data1} onChange={({ target: { checked } }) => setData1(checked)} />
              </Td>
            </tr>
          </tbody>
        </table>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" rowSpan={2} style={{ textAlign: "center", width: 10 }}>
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 400 }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", minWidth: 200 }}>
                Giá trị giao dịch liên kết
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 400 }}>
                Giá trị giao dịch với các bên độc lập
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 400 }}>
                Tổng giá trị phát sinh từ hoạt động kinh doanh trong kỳ
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Giá trị xác định theo Hồ sơ xác định giá giao dịch liên kết
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Giá trị xác định giá theo APA
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>(1)</Td>
              <Td style={{ textAlign: "center" }}>(2)</Td>
              <Td style={{ textAlign: "center" }}>(3)</Td>
              <Td style={{ textAlign: "center" }}>(4)</Td>
              <Td style={{ textAlign: "center" }}>(5)</Td>
              <Td style={{ textAlign: "center" }}>(6) = (3) + (4) + (5)</Td>
            </tr>
            {data &&
              data.length > 0 &&
              data.map((rows, index) => (
                <tr key={index}>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: 400,
                    }}
                  >
                    {rows.stt}
                  </Td>
                  <Td
                    style={{
                      textAlign: "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    style={{
                      background:
                        rows.readOnly === true
                          ? "#ddeff3"
                          : rows.value.value3.readOnly === true
                          ? "#ddeff3"
                          : "transparent",
                    }}
                  >
                    {rows.value.value3.value !== "" && (
                      <InputTable
                        readOnlyBackground={
                          rows.readOnly === true
                            ? true
                            : rows.value.value3.readOnly === true
                            ? true
                            : false
                        }
                        readOnly={
                          rows.readOnly === true
                            ? true
                            : rows.value.value3.readOnly === true
                            ? true
                            : false
                        }
                        id={rows.id}
                        name="value3"
                        value={rows.value.value3.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    style={{
                      background:
                        rows.readOnly === true
                          ? "#ddeff3"
                          : rows.value.value4.readOnly === true
                          ? "#ddeff3"
                          : "transparent",
                    }}
                  >
                    {rows.value.value4.value !== "" && (
                      <InputTable
                        readOnlyBackground={
                          rows.readOnly === true
                            ? true
                            : rows.value.value4.readOnly === true
                            ? true
                            : false
                        }
                        readOnly={
                          rows.readOnly === true
                            ? true
                            : rows.value.value4.readOnly === true
                            ? true
                            : false
                        }
                        id={rows.id}
                        name="value4"
                        value={rows.value.value4.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    style={{
                      background:
                        rows.readOnly === true
                          ? "#ddeff3"
                          : rows.value.value5.readOnly === true
                          ? "#ddeff3"
                          : "transparent",
                    }}
                  >
                    {rows.value.value5.value !== "" && (
                      <InputTable
                        readOnlyBackground={
                          rows.readOnly === true
                            ? true
                            : rows.value.value5.readOnly === true
                            ? true
                            : false
                        }
                        readOnly={
                          rows.readOnly === true
                            ? true
                            : rows.value.value5.readOnly === true
                            ? true
                            : false
                        }
                        id={rows.id}
                        name="value5"
                        value={rows.value.value5.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    style={{
                      background:
                        rows.readOnly === true
                          ? "#ddeff3"
                          : rows.value.value6.readOnly === true
                          ? "#ddeff3"
                          : "transparent",
                    }}
                  >
                    {rows.value.value6.value !== "" && (
                      <InputTable
                        readOnlyBackground={
                          rows.readOnly === true
                            ? true
                            : rows.value.value6.readOnly === true
                            ? true
                            : false
                        }
                        readOnly={
                          rows.readOnly === true
                            ? true
                            : rows.value.value6.readOnly === true
                            ? true
                            : false
                        }
                        id={rows.id}
                        name="value6"
                        value={rows.value.value6.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
            {data2.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {stt[index] || "y"}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete2(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="content"
                    value={item.content}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value4"
                    value={item.value4}
                    onChange={handleChange2}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}></Td>
                <Td style={{ background: "#ddeff3" }}></Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd2}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, readOnlyBackground, fontWeight, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: readOnlyBackground === true ? "#ddeff3" : "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        minWidth: 180,
        borderRadius: "0.5rem",
        fontWeight: fontWeight,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
